import React, { useState } from 'react';
import { AppBar, Button, Tab, Tabs, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Auth from '../../util/Auth';
import PERMISSIONS_LIST from '../../util/RolesEnum';
import { useSnackbar } from 'notistack/build';
import EditROW from './EditROW';
import ROWChainOfTitle from './ROWChainOfTitle';
import {useMutation, useQuery} from "@apollo/client";
import {EDIT_ROW, GET_ROW} from "../../components/row/ROWQueries";
import LoadingView from "../../components/LoadingView";
import Plat from "./Plat";
import gql from "graphql-tag";
import Toolbar from '@material-ui/core/Toolbar';

const hasPermissions = Auth.hasRole(PERMISSIONS_LIST.WRITE.WRITE_WELLS);

export const ROWFormStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: 50,
  },
  TextField: {
    display: 'block',
    marginTop: 10,
    marginBottom: 10,
    paddingRight: '1em',
  },
  Switch: {
    margin: 0,
  },
  BottomBar: {
    display: hasPermissions ? 'flex' : 'none',
    justifyContent: 'space-between',
  },
  positives: {
    display: 'flex',
    flexDirection: 'row',
  },
  SubmitButton: {
    display: hasPermissions ? 'inline-block' : 'none',
    maxWidth: '200px',
    maxHeight: '50px',
    minWidth: '200px',
    float: 'left',
  },
  DeleteButton: {
    display: hasPermissions ? 'inline-block' : 'none',
    maxWidth: '200px',
    maxHeight: '50px',
    minWidth: '200px',
    float: 'right',
  },
  DIButton: {
    display: hasPermissions ? 'inline-block' : 'none',
    maxWidth: '200px',
    maxHeight: '50px',
    minWidth: '200px',
  },
  FormControlLabel: {
    paddingRight: '5em',
  },
  Select: {
    display: 'block',
  },
  FullWidthTextBox: {
    marginBottom: 20,
    marginTop: 20,
  },
  paper: {
    padding: 25,
    marginBottom: '1rem',
    marginTop: '1rem',
  },
  title: {
    color: '#1976d2',
    fontSize: '1.75rem',
    textAlign: 'left',
    textDecoration: 'underline',
  },
}));

const GET_OPERATORS = gql`
  query {
    Operator {
        id
        name
    }
  }
`;

function TabContainer(props) {
  return (
    <Typography component='div'>
      {props.children}
    </Typography>
  );
}

const GetROWFromQuery = (queryResult) => {
  if (!Array.isArray(queryResult) || queryResult.length === 0) {
    return false;
  }

  return queryResult[0];
};

const ROWTabPage = ({ match, history }) => {
  const [value, setValue] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const [modalOpen, setModalOpen] = useState(false);
  const { data, error, loading } = useQuery(GET_ROW, {
    variables: {
      id: match.params.rowID,
    },
  });
  const { data: operatorData, loading: operatorLoading, error: operatorError } = useQuery(GET_OPERATORS);



  const [EditROWQuery] = useMutation(EDIT_ROW);

  if(loading || operatorLoading) return <LoadingView/>;
  if(error || operatorError) return <p>ERROR: {error}</p>;
  const operators = operatorData.Operator;

  const ROW = data.ROW[0];


  if(data) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflowY: 'auto',
        paddingLeft: 5
      }}>
        <AppBar position='fixed'
                style={{
                  display: "flex",
                  marginBottom: 5,
                  paddingTop: "62px",
                  height: "150px"}}
        >
          <Toolbar
            style={{
              marginTop: -10,
              paddingTop: 25,
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignSelf: 'flex-start',
              paddingLeft: 215
            }}
          >
              <Tabs
                value={value}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
              >
                <Tab label='Main' />
                <Tab label='Chain Of Title' />
                <Tab label='Plat' />
              </Tabs>
              {value === 0 && (
                <div style={{ display: 'flex', flexDirection: "row", paddingLeft: 60 }}>
                  <Button
                    size={'small'}
                    onClick={() => {
                      setModalOpen(true);
                    }}
                    variant='contained' color='secondary' style={{ float: 'right', marginRight: 3}}>
                    Delete
                  </Button>
                  <Button form="editROW"
                          size={'small'}
                          variant='contained' color='primary' type='submit' style={{ float: 'right', marginRight: '4px' }}>
                    Update
                  </Button>
                </div>
              )}
              {value === 1 && (
                <div>
                  <Button
                    size={'small'}
                    onClick={() => {
                      const fileInput = document.getElementById('addFile');
                      if (fileInput) {
                        fileInput.click();
                      }
                    }}
                    variant='contained' color='primary' style={{ float: 'right' }}>
                    Upload
                  </Button>
                </div>
              )}
              {value === 2 && (
                <div>
                  <Button form="platSubmit"
                          variant='contained' color='primary' type='submit' style={{ float: 'right', marginRight: '4px' }}>
                    Submit
                  </Button>
                </div>
              )}

            </Toolbar>
          </AppBar>
        <div style={{ paddingTop: '100px' }} >
          {value === 0 && (
              <TabContainer>
                <EditROW
                  modalOpen={modalOpen}
                  setModalOpen={setModalOpen}
                  match={match} history={history} ROW={ROW}/>
              </TabContainer>
          )}
          {value === 1 && (
              <TabContainer>
                <ROWChainOfTitle
                    match={match}
                    history={history}
                    enqueueSnackbar={enqueueSnackbar}
                    setValue={setValue}
                />
              </TabContainer>
          )}
          {value === 2 && (
              <TabContainer>
                <Plat ROW={ROW} EditROW={EditROWQuery} setNotification={enqueueSnackbar}/>
              </TabContainer>
          )}
        </div>
      </div>
    );
  }
};

export default ROWTabPage;
